import { differenceInSeconds } from 'date-fns';

export const secondsUntilDate = (date: Date): number => {
  const today = new Date();
  return differenceInSeconds(date, today);
};

export const quotient = (dividend: number, divisor: number): number =>
  Math.floor(dividend / divisor);
